module.exports = __webpack_public_path__ + "assets/img/page1-design-side-nav-expand-a214311d.png";